<form [formGroup]="raisonAnnulationForm" (ngSubmit)="addRaisonAnnulation()">
  <div class="form-container">
    <div>
      <label>{{'referentiels.list.raisonAnnulationProperties.raison.header' | transloco }}<span class="required">*</span></label>
      <input pInputText formControlName="raison" />
      <small class="p-error block">
        @if (raisonAnnulationForm.controls.raison.errors?.required) {
          <p-message *ngIf="raisonAnnulationForm.controls['raison'].invalid && raisonAnnulationForm.controls['raison'].touched" severity="danger" text="Le champ pour la raison est requis."></p-message>
        } @else if (raisonAnnulationForm.controls.raison.errors?.maxlength) {
          <p-message *ngIf="raisonAnnulationForm.controls['raison'].invalid && raisonAnnulationForm.controls['raison'].touched" severity="danger" text="La raison ne doit pas dépasser 150 caractères."></p-message>
        }
      </small>
    </div>
  </div>

  <div class="button-container">
    <p-button [rounded]="true" pRipple label="{{ 'button.cancel' | transloco }}" (onClick)="close(false)" />
    <p-button [rounded]="true" type="submit" [disabled]="raisonAnnulationForm.invalid" pRipple label="{{ 'button.validate' | transloco }}" />
  </div>

  <div *ngIf="submitting" class="loading-spinner">
    <p-progressSpinner [style]="{ width: '3rem', height: '3rem' }"></p-progressSpinner>
  </div>
</form>
<p-toast />
